module.exports = __webpack_public_path__ + "media/images/flags/1x1/mne-3e0d1f93b65866322214cc713fb0ddd5.svg";